var map = {
	"./10_nuts.png": 2493,
	"./1drink_12beer.png": 2494,
	"./1serving_8ounces.png": 2495,
	"./1serving_8ounces2.png": 2496,
	"./1serving_8ounces3.png": 2497,
	"./1serving_8ounces4.png": 2498,
	"./1serving_8ounces5.png": 2499,
	"./8ounces_1glass.png": 2500,
	"./can_1.png": 2501,
	"./can_2.png": 2502,
	"./can_3.png": 2503,
	"./cup.png": 2504,
	"./dried_serving_1/4cup.png": 2505,
	"./dried_serving_1:4cup.png": 2506,
	"./fresh_serving_1cup.png": 2507,
	"./glass_1.png": 2508,
	"./glass_2.png": 2509,
	"./golfball.png": 2510,
	"./halfthumb.png": 2511,
	"./hand_1.png": 2512,
	"./hand_2.png": 2513,
	"./hand_3.png": 2514,
	"./hand_4.png": 2515,
	"./hand_5.png": 2516,
	"./how.png": 861,
	"./serving_1/2cup.png": 2517,
	"./serving_1:2cup.png": 2518,
	"./serving_1tbsp.png": 2519,
	"./serving_3/4ounces.png": 2520,
	"./serving_3:4ounces.png": 2521,
	"./thumbx2.png": 2522,
	"./usda.png": 2523,
	"./vegetables_1cup.png": 2524,
	"./what.png": 859,
	"./wholethumb.png": 2525,
	"./why.png": 860
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2492;